import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { useState } from 'react';
import BlurbToAction from './BlurbToAction';
import DoerBlock from './DoerBlock';
import FormManager from './FormManager';
import Hero from './Hero';
import JoinTeam from './JoinTeam';
import css from './AmbassadorLP.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AmbassadorLP = function AmbassadorLP(_ref) {
  var blurbToAction = _ref.blurbToAction,
      doerBlocks = _ref.doerBlocks,
      hero = _ref.hero,
      joinTeam = _ref.joinTeam;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formOpen = _useState2[0],
      setFormOpen = _useState2[1];

  var onClickCta = function onClickCta() {
    return setFormOpen(true);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Hero, _objectSpread({}, hero)), /*#__PURE__*/_jsx(JoinTeam, _objectSpread(_objectSpread({}, joinTeam), {}, {
      onClickCta: onClickCta
    })), doerBlocks.map(function (doerBlock) {
      return /*#__PURE__*/_createElement(DoerBlock, _objectSpread(_objectSpread({}, doerBlock), {}, {
        key: doerBlock.title,
        onClickCta: onClickCta
      }));
    }), /*#__PURE__*/_jsx(BlurbToAction, _objectSpread(_objectSpread({}, blurbToAction), {}, {
      onClickCta: onClickCta
    })), /*#__PURE__*/_jsx(FormManager, {
      onHide: function onHide() {
        return setFormOpen(false);
      },
      open: formOpen
    })]
  });
};

AmbassadorLP.propTypes = {
  blurbToAction: PropTypes.shape(_objectSpread({}, BlurbToAction.propTypes)).isRequired,
  doerBlocks: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, DoerBlock.propTypes))).isRequired,
  hero: PropTypes.shape(_objectSpread({}, Hero.propTypes)).isRequired,
  joinTeam: PropTypes.shape(_objectSpread({}, JoinTeam.propTypes)).isRequired
};
export default AmbassadorLP;